<div class="card calendar">  
	<div class="card-header calendar-header">
		<!-- <div class="btn-group calendar-change-view-btns">
			<div class="btn btn-light"
				(click)="setView(CalendarView.Day)"
				[class.active]="view === CalendarView.Day">
				Dia
			</div>			
			<div class="btn btn-light"
				(click)="setView(CalendarView.Week)"
				[class.active]="view === CalendarView.Week">
				Semana
			</div>
			<div class="btn btn-light"
				(click)="setView(CalendarView.Month)"
				[class.active]="view === CalendarView.Month">
				Mês
			</div>			
		</div>		 -->

		<h4 class="calendar-view-date-title">{{ viewDate | calendarDate:(view + 'ViewTitle'): locale }}</h4>

		<div class="calendar-change-view-date-btns btn-group">
			<div class="btn btn-light"
				mwlCalendarPreviousView
				[view]="view"
				[viewDate]="viewDate"
				(viewDateChange)="onViewDateChange($event)">
				<i class="fas fa-long-arrow-alt-left"></i>
			  </div>
			<div class="btn btn-light"
				mwlCalendarToday
				[viewDate]="viewDate"
				(viewDateChange)="onViewDateChange($event)">
				Hoje
			</div>			
			<div class="btn btn-light"
				mwlCalendarNextView
				[view]="view"
				[viewDate]="viewDate"
				(viewDateChange)="onViewDateChange($event)">
				<i class="fas fa-long-arrow-alt-right"></i>
			</div>
		</div>
	</div>
	<div class="card-body calendar-body" #calendarBody>
		<div [ngSwitch]="view">
			<!-- Day -->
			<mwl-calendar-day-view
				*ngSwitchCase="CalendarView.Day"
				[viewDate]="viewDate"
				[events]="events"
				[locale]="locale"
				(eventClicked)="eventClicked.emit($event.event)"
				(eventTimesChanged)="eventTimesChanged($event)">
			</mwl-calendar-day-view>

			<!-- Week -->
			<mwl-calendar-week-view
				*ngSwitchCase="CalendarView.Week"
				[viewDate]="viewDate"
				[events]="events"
				[locale]="locale"
				(eventClicked)="eventClicked.emit($event.event)"
				(eventTimesChanged)="eventTimesChanged($event)">
			</mwl-calendar-week-view>

			<!-- Month -->
			<span *ngSwitchCase="CalendarView.Month">
				<sgt-calendar-month-view-mini
					*ngIf="isBreakPointSmall"
					[(viewDate)]="viewDate"
					[(startDate)]="startDate"
					[(endDate)]="endDate"
					(datesChange)="datesChange.emit()"
					[events]="events"
					[locale]="locale"
					(eventClicked)="eventClicked.emit($event)"
					[eventTemplate]="eventTemplate">
				</sgt-calendar-month-view-mini>			
	
				<mwl-calendar-month-view
					*ngIf="!isBreakPointSmall"
					[viewDate]="viewDate"
					[events]="events"
					[locale]="locale"
					(dayClicked)="dayClicked($event.day)"
					(eventClicked)="eventClicked.emit($event.event)"
					(eventTimesChanged)="eventTimesChanged($event)"
					[cellTemplate]="customCellMonthTemplate">
				</mwl-calendar-month-view>
			</span>			
		</div>		
	</div>
</div>


<ng-template
	#customCellMonthTemplate
	let-day="day"
	let-openDay="openDay"
	let-locale="locale"
	let-tooltipPlacement="tooltipPlacement"
	let-highlightDay="highlightDay"
	let-unhighlightDay="unhighlightDay"
	let-eventClicked="eventClicked"
	let-tooltipTemplate="tooltipTemplate"
	let-tooltipAppendToBody="tooltipAppendToBody">

	<div class="cal-day">
		<div class="cal-cell-top">
			<span class="cal-day-number">{{ day.date | calendarDate:'monthViewDayNumber':locale }}</span>
		</div>
		<div class="cal-events" *ngIf="day.events?.length > 0">

			<div class="cal-event-container {{getEventContainerClass(event, day)}}"
				*ngFor="let event of day.events | calendarEventsLimitFilter: (day.meta ? day.meta.limitEventsShowing : limitEventsShowing); trackBy:trackByEventId"
				[ngClass]="event?.cssClass"
				(mouseenter)="highlightDay.emit({event: event})"
				(mouseleave)="unhighlightDay.emit({event: event})"
				[mwlCalendarTooltip]="event.title | calendarEventTitle:'monthTooltip':event"
				[tooltipPlacement]="tooltipPlacement"
				[tooltipEvent]="event"
				[tooltipTemplate]="tooltipTemplate"
				[tooltipAppendToBody]="tooltipAppendToBody"
				mwlDraggable
				[class.cal-draggable]="event.draggable"
				dragActiveClass="cal-drag-active"
				[dropData]="{event: event, draggedFrom: day}"
				[dragAxis]="{x: event.draggable, y: event.draggable}"
				(mwlClick)="eventClicked.emit({ event: event })"
				[ngStyle]="getEventContainerStyle(event, day)">
	
				<div class="cal-event-content">
					<div class="cal-event"
						[ngStyle]="{'background-color': event.color?.secondary, 'color': event.color?.primary, 'border-width': '2px', 'border-style': 'solid', 'border-color': event.color?.primary}">

						<div *ngIf="event.actions?.length > 0" class="dropdown dropdown-actions" (click)="dropdownEventActionsClick(dropdownEventActions, $event)" #dropdownEventActions>
							<button type="button" class="btn btn-link dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true" tabindex="-1" [ngStyle]="{'color': event.color?.primary}">
								<i class="fas fa-ellipsis-h" aria-hidden="true"></i>
							</button>
							<div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenu">
								<a class="dropdown-item {{action.cssClass}}" *ngFor="let action of event.actions" (click)="actionClick(event, action, $event, dropdownEventActions)">
									<span [innerHtml]="action.label"></span> {{action.a11yLabel}}
								</a>
							</div>
						</div>

						<div class="cal-event-body" [ngStyle]="{'color': event.color?.primary}">
							<ng-template
								[ngTemplateOutlet]="eventTemplate || defaultEventTemplate"
								[ngTemplateOutletContext]="{
									event: event,
									eventMeta: event.meta ? event.meta : null
								}">
							</ng-template>	
						</div>						
					</div>
				</div>
			</div>

			<div class="cal-events-footer">
				<div class="cal-events-btns" *ngIf="day.events.length > limitEventsShowing">
					<button type="button" class="btn btn-link" (click)="showMoreEvents(day, $event)" *ngIf="!day.meta?.iShowingMoreEvents">
						<i class="fas fa-plus"></i> Mais {{day.events.length - limitEventsShowing}}
					</button>
					<button type="button" class="btn btn-link" (click)="showLessEvents(day, $event)" *ngIf="day.meta?.iShowingMoreEvents">
						<i class="fas fa-minus"></i> Menos {{day.events.length - limitEventsShowing}}
					</button>
				</div>
			</div>
		</div>
	</div>
</ng-template>

<ng-template
	#defaultEventTemplate
	let-event="event">
	<h6 class="cal-event-title" [ngStyle]="{'color': event.color?.primary}">
		{{event.title}}
	</h6>
</ng-template>